import { createContext, useState, useEffect } from "react";

export const EditorContext = createContext<any>({});

type EditorProps = {
  children: React.ReactNode; //👈 children prop type
};

export const EditorProvider = ({ children }: EditorProps) => {
  const [editorContent, setEditorContent] = useState<any>();
  const [editorUpdate, setEditorUpdate] = useState<any>(false);

  return (
    <EditorContext.Provider
      value={{ editorContent, editorUpdate, setEditorContent, setEditorUpdate }}
    >
      {children}
    </EditorContext.Provider>
  );
};
